import $ from 'jquery';
import '../../lib/bootstrap-toggle.min';
import '../../lib/bootstrap-dropdownhover.min';
import I18n from "i18n-js";

$(document).ready(function() {
  loadLocale();

  function loadLocale() {
    const locales = import(`../../vue-app/localisation/${window.locale}.json`);
    I18n.locale = window.locale;
    locales.then((localeModule) => {
      I18n.translations[window.locale] = localeModule;
    });
  }
});

$(document).on('submit', '#api-request-form', function(e) {
  e.preventDefault();
  e.stopPropagation();
  return false;
});

$(document).on('click', '.createApiButton', function() {
  $('#createApiDialog').modal('show');
});

$(document).on('click', '.api-submit-btn', function(e) {
  let hasError = false;
  const validation = validateApiRequest();
  if (Object.keys(validation.errors).length) {
    hasError = true;
    showValidationErrors(validation.errors);
  } else if (!validation.selectedPackage) {
    hasError = true;
    $('#needSelectService').modal('show');
  }

  if (!hasError) {
    $.ajax({
      url: '/profile/api_request',
      type: 'POST',
      headers: {'X-CSRF-Token': $('meta[name=csrf-token]').attr('content')},
      data: $('#api-request-form').serialize(),
      success: function(data) {
        if (inProfile()) {
          $('#createApiDialog').modal('show');
          window.location.reload();
        } else {
          window.location.href = ['ru', 'en'].indexOf(window.locale) > -1 ? '/profile#api_tab' : '/' + window.locale + '/profile#api_tab';
        }
      }
    });
  }
  return false;
});

function showValidationErrors(errors) {
  ['live', 'prematch'].forEach(function(node) {
    ['bot_arbs', 'bot_valuebets'].forEach(function(packageType) {
      const name = node+'_'+packageType;
      if (errors[name]) {
        if (errors[name] == 'error') {
          const message = I18n.t('landing_api.please_select_bookmakers');
          showError(message, name);
        }
      }
    });
  });
  if (errors['api-comment'] == 'error') {
    $('.api-request-row-textarea .errors').html(I18n.t('landing_api.please_add_comment')).removeClass('hidden');
  }
}

function showError(message, componentId) {
  const errorDiv = $('#'+componentId).parents('.api-request-row').find('.errors');
  errorDiv.html(message).removeClass('hidden');
}

function validateApiRequest() {
  let errors = {};
  let selectedPackage = false;

  $('.errors').html('').addClass('hidden');

  ['live', 'prematch'].forEach(function(node) {
    ['bot_arbs', 'bot_valuebets'].forEach(function(packageType) {
      const validation = validateApiRow(node, packageType);
      const name = node+'_'+packageType;
      if (validation[name] == 'error') {
        errors = Object.assign(errors, validation);
      } else if (validation[name] == 'ok') {
        selectedPackage = true;
      }
    });
  });

  if ($('#api-comment').val().length < 1) {
    errors = Object.assign(errors, {'api-comment': 'error'});
  }

  return {errors: errors, selectedPackage: selectedPackage};
}

function validateApiRow(node, packageType) {
  const name = node+'_'+packageType;
  const res = {};
  if ($('#'+name+':checked').length > 0) {
    if ($('#'+name+'_bk_list').val() == '') {
      res[name] = 'error';
    } else {
      res[name] = 'ok';
    }
  } else {
    res[name] = 'not_checked';
  }
  return res;
}

function inProfile() {
  return window.location.href.indexOf('/profile') > -1;
}
